import { createSlice } from "@reduxjs/toolkit";
import clienteAntesala from "../../../config/Config";

const initialState = {
  me: null,
};

export const meSlice = createSlice({
  name: "me",
  initialState: initialState,
  reducers: {
    setMe: (state, action) => {
      state.me = action.payload
    }
  },
});

//Async functions
export const fetchMe = (params) => (dispatch) => {
  clienteAntesala
    .get(params.url, { params })
    .then((result) => {
      return dispatch(setMe(result.data));
    })
    .catch((error) => {
      if (error.response) {
        return error.response.data;
      } else if (error.request) {
        return error.request.data;
      } else {
        return error.message;
      }
    });
};

export const { setMe } = meSlice.actions;

export const meState = (state) => state.me;

export default meSlice.reducer;
